import { render, staticRenderFns } from "./UserInfoModal.vue?vue&type=template&id=461de8e3&scoped=true&"
import script from "./UserInfoModal.vue?vue&type=script&lang=js&"
export * from "./UserInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461de8e3",
  null
  
)

export default component.exports